import request from '@/utils/request'

// 获取列表
export function getTicketManList(data) {
  return request({
    url: '/admin/operate/webTicketMan/list',
    method: 'post',
    data
  })
}

// crm票券列表
export function getCrmlist(data) {
  return request({
    url: '/admin/operate/webTicketMan/crmlist',
    method: 'get',
    data
  })
}

// 添加
export function addTicketMan(data) {
  return request({
    url: '/admin/operate/webTicketMan/add',
    method: 'post',
    data
  })
}

// 修改
export function updateTicketMan(data) {
  return request({
    url: '/admin/operate/webTicketMan/edit',
    method: 'post',
    data
  })
}
// 排序
export function sortTicketMan(data) {
  return request({
    url: '/admin/operate/webTicketMan/sortEdit',
    method: 'post',
    data
  })
}

// 删除
export function removeTicketMan(data) {
  return request({
    url: '/admin/operate/webTicketMan/remove',
    method: 'post',
    data
  })
}

// 票券记录
export function getTicketRecordList(data) {
  return request({
    url: '/admin/operate/webTicketRecord/list',
    method: 'post',
    data
  })
}
